import styled from '@emotion/styled';
import type { ExtractedAnswersAPI } from '@trinity/chat';
import { ConfidenceBadge } from './ConfidenceBadge';
import { AnswerValueDisplay } from './AnswerValueDisplay';
import { SourceSnippetPanel } from './SourceSnippetPanel';

const Card = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  background: #fff;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 8px;
`;

const QuestionText = styled.div`
  font-family: var(--font-semibold);
  flex: 1;
`;

const Label = styled.div`
  color: var(--gray-d);
  margin-bottom: 4px;
`;

const Pending = styled.div`
  font-size: 13px;
  color: #999;
  font-style: italic;
`;

type Props = {
  item: ExtractedAnswersAPI.GetExtractedAnswers.ExtractedAnswerItem;
  transcriptId: number;
};

export function ExtractedAnswerCard({ item, transcriptId }: Props): React.ReactElement {
  const { question, answerData } = item;
  const config = question.answerConfig;

  return (
    <Card>
      <Label>{config.label}</Label>
      <Header>
        <QuestionText>{config.questionText}</QuestionText>
        {answerData && (
          <ConfidenceBadge confidence={answerData.confidence} rationale={answerData.confidenceRationale} />
        )}
      </Header>

      {!answerData && !item.completedOn && <Pending>Extracting…</Pending>}

      {answerData && (
        <>
          <AnswerValueDisplay answer={answerData} />
          <SourceSnippetPanel snippets={answerData.sourceSnippets} transcriptId={transcriptId} />
        </>
      )}
    </Card>
  );
}
